var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-dialog',{ref:"viewBatchRouteModal"},[_c('md-dialog-content',[(_vm.batch)?_c('traceability-maps',{attrs:{"o-s-alvaro":_vm.exam.idOrder,"locations":_vm.mapLocations,"laboratory":{
        name: _vm.batch.laboratory.labName,
        address: _vm.batch.laboratory.address
      },"nto":{
        name: 'NTO ' + (_vm.batch.nto.address?.city || ''),
        address: _vm.batch.nto.address
      },"current-location":{
        address: _vm.batch.currentBatchLocation.address,
        position: {
          lat: _vm.batch.currentBatchLocation.latitude,
          lng: _vm.batch.currentBatchLocation.longitude
        },
        lastUpdated: _vm.batch.currentBatchLocation.lastUpdated
      },"button-action":() => _vm.close(),"button-label":"VER AMOSTRAS"}}):_vm._e()],1)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }